export const ALL_ITEM_JEWELRYCASES = [
  {
    categry: "jewelryCases",
    itemList: [
      {
        itemSelected: "aria",
        itemName: "Aria",
        itemDescription:
          "Aria is a custom-made jewelry case designed to provide your jewelry with the ultimate protection. ",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryCases/Aria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Aria-01.webp",
          "/images/listItem/jewelryCases/Aria/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Aria-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryCases/Aria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Aria-01.webp",
          "/images/listItem/jewelryCases/Aria/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Aria-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryCases/Aria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Aria-01.webp",
          "/images/listItem/jewelryCases/Aria/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Aria-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryCases/Aria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Aria-01.webp",
          "/images/listItem/jewelryCases/Aria/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Aria-02.webp",
        ],
      },
      {
        itemSelected: "aurora",
        itemName: "Aurora",
        itemDescription:
          "Aurora is a custom-made jewelry case designed to provide your jewelry with the ultimate protection.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryCases/Aurora/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Aurora-01.webp",
          "/images/listItem/jewelryCases/Aurora/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Aurora-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryCases/Aurora/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Aurora-01.webp",
          "/images/listItem/jewelryCases/Aurora/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Aurora-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryCases/Aurora/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Aurora-01.webp",
          "/images/listItem/jewelryCases/Aurora/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Aurora-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryCases/Aurora/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Aurora-01.webp",
          "/images/listItem/jewelryCases/Aurora/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Aurora-02.webp",
        ],
      },
      {
        itemSelected: "casa",
        itemName: "Casa",
        itemDescription:
          "Casa is a custom-made jewelry case designed to provide your jewelry with the ultimate protection.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryCases/Casa/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Casa-01.webp",
          "/images/listItem/jewelryCases/Casa/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Casa-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryCases/Casa/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Casa-01.webp",
          "/images/listItem/jewelryCases/Casa/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Casa-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryCases/Casa/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Casa-01.webp",
          "/images/listItem/jewelryCases/Casa/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Casa-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryCases/Casa/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Casa-01.webp",
          "/images/listItem/jewelryCases/Casa/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Casa-02.webp",
        ],
      },
      {
        itemSelected: "mare",
        itemName: "Mare",
        itemDescription:
          "Mare is a custom-made jewelry case designed to provide your jewelry with the ultimate protection.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryCases/Mare/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Mare.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryCases/Mare/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Mare.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryCases/Mare/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Mare.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryCases/Mare/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Mare.webp",
        ],
      },
      {
        itemSelected: "zoey",
        itemName: "Zoey",
        itemDescription:
          "Zoey is a custom-made jewelry case designed to provide your jewelry with the ultimate protection.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/jewelryCases/Zoey/Desktop/700x700px/Lussopack-Packaging-Jewelry-Case-Zoey.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/jewelryCases/Zoey/Desktop/130x130px/Lussopack-Packaging-Jewelry-Case-Zoey.webp",
        ],
        itemMobileBig: [
          "/images/listItem/jewelryCases/Zoey/Mobile/335x335px/Lussopack-Packaging-Jewelry-Case-Zoey.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/jewelryCases/Zoey/Mobile/100x100px/Lussopack-Packaging-Jewelry-Case-Zoey.webp",
        ],
      },
    ],
  },
];
